import { prop } from 'ramda';
import { getCleanPath } from 'js/utils/url.util';
import { usePageSelector } from 'js/store/hooks';

export const useGetBackgroundPage = () => {
    const popupBackgroundPagePath = usePageSelector(prop('popupBackgroundPagePath'));

    return getCleanPath(popupBackgroundPagePath || '/');
};
